const getRandomIntInclusive = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min; // Максимум и минимум включаются
const LINE_LIMIT = 200;

export const createLine1 = (ctx, width, height, color) => {
    if (width < LINE_LIMIT) return;

    const lineWhite1 = {
        x: getRandomIntInclusive(Math.ceil((width / 2) * 0.02), Math.ceil((width / 2) * 0.05)),
        y: getRandomIntInclusive(Math.ceil((height) * 0.2), Math.ceil((height) * 0.7)),
        width: getRandomIntInclusive(Math.ceil((width / 2) * 0.2), Math.ceil((width / 2) * 0.9)),
    };

    ctx.fillStyle = color;
    ctx.fillRect(lineWhite1.x, lineWhite1.y, lineWhite1.width, 1);
};

export const createLine2 = (ctx, width, height, color) => {
    const lineWhite2 = {
        x: getRandomIntInclusive(Math.ceil((width / 2) + (width / 2) * 0.02), Math.ceil((width / 2) + (width / 2) * 0.05)),
        y: getRandomIntInclusive(Math.ceil((height) * 0.2), Math.ceil((height) * 0.7)),
        width: getRandomIntInclusive(Math.ceil((width / 2) * 0.2), Math.ceil((width / 2) * 0.9)),
    };

    ctx.fillStyle = color;
    ctx.fillRect(lineWhite2.x, lineWhite2.y, lineWhite2.width, 1);
};

export const createLine3 = (ctx, width, height, color) => {
    const lineWhite3 = {
        x: getRandomIntInclusive(Math.ceil((width) * 0.01), Math.ceil((width) * 0.03)),
        y: getRandomIntInclusive(Math.ceil((height) * 0.85), Math.ceil((height) * 0.95)),
        width: getRandomIntInclusive(Math.ceil((width / 2) * 0.2), Math.ceil((width / 2) * 0.9)),
    };

    ctx.fillStyle = color;
    ctx.fillRect(lineWhite3.x, lineWhite3.y, lineWhite3.width, 1);
};

export const createLine4 = (ctx, width, height, color) => {
    if (width < LINE_LIMIT) return;

    const lineWhite4 = {
        x: getRandomIntInclusive(Math.ceil((width / 2) + (width / 2) * 0.6), Math.ceil((width / 2) + (width / 2) * 0.8)),
        y: getRandomIntInclusive(Math.ceil((height) * 0.85), Math.ceil((height) * 0.95)),
        width: getRandomIntInclusive(Math.ceil((width / 2) * 0.02), Math.ceil((width / 2) * 0.09)),
    };

    ctx.fillStyle = color;
    ctx.fillRect(lineWhite4.x, lineWhite4.y, lineWhite4.width, 1);
};
